import {
  Row,
  Button,
  Form,
  Select,
  Radio,
  Switch,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notifications from 'components/theme_components/Notifications';
import { useQuery, useQueryClient } from 'react-query';
import { 
  getProductList, 
  createConversionRule, 
  updateConversionRule,
  ProductConversionRuleResponse 
} from 'services/parametersService';
import { useEffect } from 'react';

export type ParRuleModalProps = {
  setVisible: (visible: boolean) => void;
  mode: 'create' | 'modify';
  data?: any;
  searchParams?: any;
  editData?: ProductConversionRuleResponse | null;
onSuccess?: () => void | Promise<any>; };

const ParRuleModal = ({ setVisible, mode, data, editData, onSuccess }: ParRuleModalProps) => {
   const [form] = useForm();
  const queryClient = useQueryClient();

  // Récupérer la liste des produits
  const { data: products, isLoading } = useQuery('productList', () =>
    getProductList().then(res => res.list || [])
  );

  // Populate form with edit data when in modify mode
  useEffect(() => {
    if (mode === 'modify' && editData) {
      form.setFieldsValue({
        sourcePrcode: editData.sourcePrcode,
        targetPrcode: editData.targetPrcode,
        isAuthorized: editData.isAuthorized,
      });
    }
  }, [mode, editData, form]);
const handleSuccess = () => {
 
    queryClient.invalidateQueries('conversionRules');

    if (onSuccess) {
      onSuccess();
    }
    
    setVisible(false);
  };



  const submit = async () => {
    try {
      const values = await form.validateFields();

      if (mode === 'modify' && editData) {
        // Update existing rule (PUT request)
        updateConversionRule({
          id: editData.rulid,
          request: values
        }).then((response) => {
          if (response.code === '200') {
            Notifications({
              status: 'success',
              message: 'La règle a été modifiée avec succès',
              duration: 2,
              placement: 'top',
            });
            handleSuccess();
            setVisible(false);
          } else {
            Notifications({
              status: 'error',
              message: response.message,
              duration: 2,
              placement: 'top',
            });
          }
        });
      } else {
        // Create new rule (POST request)
        createConversionRule({ request: values }).then((response) => {
          if (response.code === '200') {
            Notifications({
              status: 'success',
              message: 'La règle a été créée avec succès',
              duration: 2,
              placement: 'top',
            });
            setVisible(false);
            handleSuccess();
          } else {
            Notifications({
              status: 'error',
              message: response.message,
              duration: 2,
              placement: 'top',
            });
          }
        });
      }
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Form
      form={form}
      className="no-border-radius ut-wizard-form"
      layout="vertical"
      initialValues={data || { isAuthorized: true }}
    >
      <Row gutter={16}>
        <Form.Item
          name="sourcePrcode"
          label="Produit source"
          rules={[{ required: true, message: 'Veuillez sélectionner un produit source' }]}
          style={{ width: '100%' }}
        >
          <Select
            showSearch
            loading={isLoading}
            placeholder="Sélectionner un produit source"
            options={products?.map(p => ({
              label: `${p.prlabel}`,
              value: p.prcode,
            }))}
          />
        </Form.Item>

        <Form.Item
          name="targetPrcode"
          label="Produit cible"
          rules={[{ required: true, message: 'Veuillez sélectionner un produit cible' }]}
          style={{ width: '100%' }}
        >
          <Select
            showSearch
            loading={isLoading}
            placeholder="Sélectionner un produit cible"
            options={products?.map(p => ({
              label: `${p.prlabel}`,
              value: p.prcode,
            }))}
          />
        </Form.Item>
        <Form.Item
            name="isAuthorized"
            label="isAuthorized"
            valuePropName="checked" 
                    style={{ width: '100%' }}
                     >
             <Switch checkedChildren="Oui" unCheckedChildren="Non" />
          </Form.Item>

      {/*   <Form.Item
          name="isAuthorized"
          label="Conversion"
          rules={[{ required: true }]}
          style={{ width: '100%' }}
        >
          <Radio.Group>
            <Radio value={false}>Manuellement</Radio>
            <Radio value>Automatiquement</Radio>
          </Radio.Group>
        </Form.Item>*/}
      </Row>

      <Row justify="end" style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => setVisible(false)}
        />
        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn ml-6"
          onClick={submit}
          iconPosition="end"
        />
      </Row>
    </Form>
  );
};

export default ParRuleModal;